import base from './base/base';
import guardian from './guardian/guardian';

export default {
  base,
  guardian,
};
